import { FC, useEffect } from "react";

import { iApiConfig } from "../../interfaces";
import { blockchain, discountPercents } from "../../settings";
import { useStoreDispatch } from "../../store/store";
import { connectKAS, getConfig } from "../../utils/helpers";
import { getItems, getStateQuery, getTimeQuery } from "../../utils/Chromia/queries";
import { BigNumber } from "../../classes/BigNumber";

import Loader from "../Loader/Loader";

import './StartUpPage.scss';


const StartUpPage: FC = () => {

	const {setIsInited, setMinDeposit, setItem, setEndTime} = useStoreDispatch();

	useEffect(() => {
		switch (blockchain) {
			case 'binance':
				getConfigs();
				break;

			case 'chromia':
				initChr();
				break
		}
		// eslint-disable-next-line
	}, [])

	const getConfigs = async () => {
		let promises: Promise<iApiConfig>[] = [];
		discountPercents.forEach(percent => {
			promises.push(getConfig(percent));
		});
		/* const res =  */await Promise.allSettled(promises);
		setIsInited();
	}

	const initChr = async () => {
		await connectKAS();
		const items = await getItems();
		// const nowTs = await getTimeQuery();
		const promises = discountPercents.map(async percent => {
				const foundItem = items.find(item => item.discount_ut.mul(100, {raiseValue: true}).valueBN18.eq(new BigNumber(percent).valueBN18));
				if (foundItem){
					setItem(percent, foundItem);
					setMinDeposit(percent, foundItem.min_depo);
					const state = await getStateQuery(foundItem.acc);
					setEndTime(percent, state.end_time)
					// setIsDepositAvailable(percent, state.end_time - day > nowTs)
				}
		})
		/* discountPercents.forEach(async percent => {
			const foundItem = items.find(item => item.discount_ut.mul(100, {raiseValue: true}).valueBN18.eq(new BigNumber(percent).valueBN18));
			foundItem && setItem(percent, foundItem);
			foundItem && setMinDeposit(percent, foundItem.min_depo);
			const state = await getStateQuery()
		}); */
		await Promise.all(promises);
		setIsInited();
	}


	return (
		<div className="StartUpPage">
			{/* Loading... */}
			<Loader/>
		</div>
	)
}

export default StartUpPage;